import { useState, ReactElement } from 'react';
import { Point } from './Point/Point';
import { Point3_1 } from './Point/Point3_part1';
import { Point3_2 } from './Point/Point3_part2';
import useWindowWidth from "../../common/WindowWidth"; 
import { useTranslation,Trans } from 'react-i18next';

import { GenericSlider } from "../../common/GenericSlider/GenericSlider";
import classes from './PointCarousel.module.scss';
import { CustomNextArrow, CustomPrevArrow } from '../../common/GenericSlider/SliderArrows/SliderArrows'; 

export const PointCarousel = () => {
  const { t } = useTranslation();
  const windowWidth = useWindowWidth(); 
  const [currentSlide, setCurrentSlide] = useState(0);
  const totalSlides = windowWidth <= 1024 ? 4 : 3; 

  const isMobile = windowWidth <= 1024;

  const customSettings = {
    infinite: false, 
    centerPadding: '0',
    beforeChange: (current, next) => setCurrentSlide(next),
      nextArrow: <CustomNextArrow hide={currentSlide === totalSlides - 1} />,
      prevArrow: <CustomPrevArrow hide={currentSlide === 0} />,
  };


  const pointData = [
    {
      number: '01',
      title: <Trans i18nKey="about:point.01.title" />,
      description: <Trans i18nKey="about:point.01.description" />
    },
    {
      number: '02',
      title: t('about:point.02.title'),
      description: <Trans i18nKey="about:point.02.description" />
    },
    {
      number: '03',
      title: t('about:point.03.title'),
    }
  ];
  

return (
  <div className={classes.sliderWrap}>
    <GenericSlider settings={customSettings}>
      {(() => {
        // 空の配列を作成
        const slides: ReactElement[] = [];
        
        for (let index = 0; index < pointData.length; index++) {
          const point = pointData[index];

          if (index !== 2) {
            slides.push(<Point key={index} {...point} />);
          } else {
            if (isMobile) {
              slides.push(<Point key={index + 'a'} {...point} className={classes.specialSlide} contentPart="part1"><Point3_1 /></Point>);
              slides.push(<Point key={index + 'b'} {...point} className={classes.specialSlide} contentPart="part2"><Point3_2 /></Point>);
            } else {
              slides.push(
                <Point key={index} {...point} className={classes.specialSlide}>
                  <div className={classes.carouselContainer}>
                  <Point3_1 />
                  <Point3_2 />
</div>
                </Point>
              );
            }
          }
        }
        return slides;
      })()}
    </GenericSlider>
  </div>
);

    };